import React from "react";
import { Link } from "react-router-dom";
import {
  FaLinkedin,
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>DexteR Technology</h3>
            <p>
              Your trusted partner in precision manufacturing and custom parts
              solutions. Delivering excellence since 2022.
            </p>
            <div className="social-links">
              <a
                href="https://www.linkedin.com/in/ravi-patel-744823173?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://wa.me/919099999763 "
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li>
                <Link to="/services/machining-capabilities">
                  Machining Capabilities
                </Link>
              </li>
              <li>
                <Link to="/services/industry-served">Industry Served</Link>
              </li>
              <li>
                <Link to="/services/quality-testing">
                  Quality Testing & Inspection
                </Link>
              </li>
              <li>
                <Link to="/services/raw-materials">
                  Raw Materials & Treatments
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p>
                <strong>Address:</strong> Plot Number 1451, Almighty Gate - 2,
                Metoda G.I.D.C. , Ta- Lodhika, Dist- Rajkot - 360021, Gujarat,
                India
              </p>
              <p>
                <strong>Phone:</strong>{" "}
                <a href="tel:+919099999763 " className="contact-link">
                  +91 90 99999 763
                </a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:info@dextertechnology.in"
                  className="contact-link"
                >
                  info@dextertechnology.in
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>
              &copy; {new Date().getFullYear()} DexteR Technology. All rights
              reserved.
            </p>
            <p className="developer-credit">
              Developed by{" "}
              <a
                href="https://siddhisolutions.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="developer-link"
              >
                Siddhi Solutions
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
